import React from "react";
import WeaSwitch from "../../wea-switch";
import {
  WeaTools,
  WeaDialog,
  WeaLocaleProvider,
  WeaTop,
  WeaFormItem,
  WeaSelect,
  WeaSearchGroup
} from "ecCom";
import { toJS } from "mobx";
import { Button } from "antd";
import { inject, observer } from "mobx-react";
const getLabel = WeaLocaleProvider.getLabel;
const { getKey } = WeaTools;

@observer
class Main extends React.Component {
  constructor(props) {
    super(props);
  }

  onSaveWorkflowForm = () => {
    const { systemSetStore } = this.props;
    const { workflowForm } = systemSetStore;
    workflowForm.validateForm().then(f => {
      if (f.isValid) {
        systemSetStore.saveWorkflowDetail();
      } else {
        f.showErrors();
      }
    });
  };

  getWorkflowDetailItems = (form, datas, needTigger = true, hide) => {
    const { systemSetStore } = this.props;
    const { isFormInit } = form;
    let group = [];
    const formParams = form.getFormParams();
    isFormInit &&
      datas &&
      datas.map((c, index) => {
        let items = [];
        c.items.map(fields => {
          if (getKey(fields) === c.newArrivalKey) {
            items.push({
              com: (
                <WeaFormItem
                  label={`${fields.label}`}
                  labelCol={{ span: fields.labelcol }}
                  wrapperCol={{ span: fields.fieldcol }}
                  fieldType={fields.conditionType.toUpperCase()}
                  error={form.getError(fields)}
                  tipPosition="bottom"
                >
                  <WeaSwitch
                    fieldConfig={fields}
                    form={form}
                    formParams={formParams}
                    onChange={v => {
                      this.changeWorkflowCondition(v);
                    }}
                  />
                  <Button
                    type="ghost"
                    size="small"
                    style={{
                      marginRight: "-100px",
                      marginLeft: "18px",
                      height: "30px"
                    }}
                    onClick={v => {
                      this.syncWorkflowPath(fields.domkey);
                    }}
                  >
                    {getLabel(506099, "同步")}
                  </Button>
                  <WeaSelect
                    options={c.options}
                    detailtype={2}
                    value={c.value}
                    onChange={v => {
                      systemSetStore.changeConditionValue(v);
                    }}
                  />
                </WeaFormItem>
              ),
              colSpan: 1,
              hide: form.isHide(fields, (keys, allParams) => {
                if (hide) {
                  return hide(getKey(fields), keys, allParams);
                }
              })
            });
          } else {
            items.push({
              com: (
                <WeaFormItem
                  label={`${fields.label}`}
                  labelCol={{ span: fields.labelcol }}
                  wrapperCol={{ span: fields.fieldcol }}
                  fieldType={fields.conditionType.toUpperCase()}
                  error={form.getError(fields)}
                  tipPosition="bottom"
                >
                  <WeaSwitch
                    fieldConfig={fields}
                    form={form}
                    formParams={formParams}
                    onChange={v => {
                      this.changeWorkflowCondition(v);
                    }}
                  />
                  <Button
                    type="ghost"
                    size="small"
                    style={{
                      marginRight: "-100px",
                      marginLeft: "18px",
                      height: "30px"
                    }}
                    onClick={v => {
                      this.syncWorkflowPath(fields.domkey);
                    }}
                  >
                    {getLabel(506099, "同步")}
                  </Button>
                </WeaFormItem>
              ),
              colSpan: 1,
              hide: form.isHide(fields, (keys, allParams) => {
                if (hide) {
                  return hide(getKey(fields), keys, allParams);
                }
              })
            });
          }
        });
        if (needTigger) {
          group.push(
            <WeaSearchGroup
              center={true}
              col={1}
              needTigger={needTigger}
              title={c.title}
              showGroup={c.defaultshow}
              items={items}
            />
          );
        } else {
          group.push(
            <WeaSearchGroup
              center={true}
              col={1}
              needTigger={needTigger}
              showGroup={c.defaultshow}
              items={items}
            />
          );
        }
      });
    return group;
  };

  changeWorkflowCondition = v => {
    const { systemSetStore } = this.props;
    const { workflowForm } = systemSetStore;
    const formParams = workflowForm.getFormParams();
    systemSetStore.changeWorkflowCondition(v);
  };

  syncWorkflowPath = value => {
    const { systemSetStore } = this.props;
    systemSetStore.showSyncWorkflowPath(value);
  };

  onChangeSelectSyncPath = value => {
    const { systemSetStore } = this.props;
    systemSetStore.setSyncPathValue(value);
  };

  render() {
    const { systemSetStore } = this.props;
    const {
      wDloading,
      workflowDetailVisiable,
      syncPathVisiable,
      dialogtitle,
      workflowForm,
      workflowCondition,
      syncPathOptions,
      syncPathValue
    } = systemSetStore;
    return (
      <div>
        <WeaDialog
          style={{ width: 650, height: 490 }}
          visible={workflowDetailVisiable}
          title={toJS(dialogtitle).dialogtitle}
          loading={wDloading}
          hasScroll={true}
          icon={"icon-coms-Flow-setting"}
          iconBgcolor="#407008"
          buttons={[
            <Button
              type="primary"
              onClick={() => {
                this.onSaveWorkflowForm();
              }}
            >
              {getLabel(86, "保存")}
            </Button>,
            <Button
              type="ghost"
              onClick={() => {
                systemSetStore.setWorkflowDetailVisiable(false);
              }}
            >
              {getLabel(201, "取消")}
            </Button>
          ]}
          onCancel={() => {
            systemSetStore.setWorkflowDetailVisiable(false);
          }}
        >
          {this.getWorkflowDetailItems(
            workflowForm,
            toJS(workflowCondition),
            true,
            (key, b, c) => {
              return false;
            }
          )}
        </WeaDialog>
        <WeaDialog
          title={getLabel(131329, "信息确认")}
          icon={"icon-coms-Prompt"}
          iconBgcolor="#fa0"
          hasScroll={true}
          style={{ width: 320, height: 140 }}
          visible={syncPathVisiable}
          buttons={[
            <Button
              type="primary"
              onClick={() => {
                systemSetStore.sureSyncWorkflowPath();
              }}
            >
              {getLabel(86, "保存")}
            </Button>,
            <Button
              type="ghost"
              onClick={() => {
                systemSetStore.setSyncPathVisiable(false);
              }}
            >
              {getLabel(201, "取消")}
            </Button>
          ]}
          onCancel={() => {
            systemSetStore.setSyncPathVisiable(false);
          }}
        >
          <div key={Math.random()} style={{ padding: 10 }}>
            <WeaFormItem
              label={getLabel(389163, "将所选路径同步到")}
              labelCol={{ span: 12 }}
              wrapperCol={{ span: 12 }}
              fieldType={"SELECT"}
              tipPosition="bottom"
            />
            <WeaSelect
              options={syncPathOptions}
              detailtype={2}
              value={syncPathValue}
              onChange={v => {
                this.onChangeSelectSyncPath(v);
              }}
            />
          </div>
        </WeaDialog>
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/components/workflowDetailSet.js